import { Injectable, inject } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiServiceBase } from './api.service.base';
import { UserStateService } from './user-state.service';

import { logger } from '../../helpers/logger';
export interface Client {
  id: number;
  name: string;
  logoUrl?: string;
}

export interface ClientLookupItem {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class ClientService extends ApiServiceBase {
  private userStateService = inject(UserStateService);
  private currentClientSubject = new BehaviorSubject<Client | null>(null);
  public currentClient$ = this.currentClientSubject.asObservable();

  getCurrentClient(): Observable<Client | null> {
    return this.userStateService.currentClient$;
  }

  getClientLookup(): Observable<ClientLookupItem[]> {
    return this.get<ClientLookupItem[]>('clients/lookup');
  }

  changeClient(clientId?: number): Observable<void> {
    return this.post<void>('users/current/client', { ClientId: clientId });
  }

  setCurrentClient(client: Client | null): void {
    this.currentClientSubject.next(client);
  }

  loadCurrentClient(): void {
    this.getCurrentClient().subscribe({
      next: client => this.setCurrentClient(client),
      error: error => {
        logger.error('Failed to load current client:', error);
        this.setCurrentClient(null);
      },
    });
  }

  getClientLogoUrl(clientId?: number): string {
    if (clientId) {
      return `/api/clients/${clientId}/logo`;
    }
    return '/Logo_Basic_Small.png';
  }
}
